import styled from 'styled-components';

interface ContainerProps {
  existCards?: boolean;
}
const Container = styled.div<ContainerProps>`
  position: relative;
  min-height: 160px;

  > div:last-of-type {
    height: ${props => props.existCards ? 150 : 80}px;
  }
`;

const Spinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 40px;
  max-height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${p => p.theme.color.background};

  svg {
    fill: ${p => p.theme.color.turquoise};
  }
`;

export const Styled = {
  Container,
  Spinner,
};
